import QuestionViewModal from "modules/question-bank/questionViewmodal";
import React, { useCallback, useEffect, useState } from "react";
import { apiPaths, getAdminData, getData, postInstituteAppData, deleteInstituteAppData, postData, getInstutueApp } from "../platform-components/api-integration-util";
import Grid from "../platform-components/grid/Grid";
import { getUserDetails } from "../platform-components/utils/shared-data.service";
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, IconButton, Modal, Tab, Tabs, TextField, Typography } from "@mui/material";
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { Toaster } from "../platform-components/Toaster";
import { toast } from "react-toastify";


const Qb = () => {
  const [testData, setTestData] = useState([]); // Store QB data
  const [loading, setLoading] = useState(true);
  const [QBCount, setQBCount] = useState(0); // Define QBCount
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [questionDataList, setQuestionDataList] = useState([]); // Store question data
  const [questionData, setQuestionData] = useState({}); // Store question data
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(-1);
  const [selectedQuestionEditable, setSelectedQuestionEditable] = useState(null); // Define selectedQuestionEditable
  const [value, setValue] = React.useState('Normal-Tests');
  const [customTestData, setCustomTestData] = useState([])
  const [normalTestData, setNormalTestData] = useState([])
  const [openAddQnModal, setOpenAddQnModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [deletedQnId, setDeletedQnId] = useState()
  const [addedQuestionId, setAddedQuestionId] = useState()
  const [libraryTestId, setLibraryTestId] = useState()
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [includeExplanation, setIncludeExplanation] = useState(false);
  const [includeAnswer, setIncludeAnswer] = useState(false);
  const [includeQuestion, setIncludeQuestion] = useState(false);

  const handleChange = ( event, newValue) => {
    setValue(newValue);
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const userDetails = getUserDetails();
      // Fetch QB data
      const response = await getAdminData(apiPaths.getLibraryTests);
      setTestData(response.result);
      const customTestDetails = response.result.filter(test => test.testMode === "CUSTOM-TEST")
      const normalTestDetails = response.result.filter(test => test.testMode !== "CUSTOM-TEST")
      setCustomTestData(customTestDetails)
      setNormalTestData(normalTestDetails)

    } catch (error) {
      console.error("Error fetching Test data:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleQuestionClick = (libraryQBModuleId) => {
    setLibraryTestId(libraryQBModuleId)
    // Handle click on a question
    // Fetch question data for the clicked question ID and set it in state
    getAdminData(`${apiPaths.getQuestionIdsByTest}?libraryTestId=${libraryQBModuleId}`).then((response) => {
      if (response.result) {
        setQuestionDataList([]);
        setQuestionDataList(response.result);
        setQBCount(response.result.length);
      }
    });
  };

  const handleQuestionIdClick = (questionId) => {
    const clickedIndex = questionDataList.indexOf(questionId);
    console.log('clickedIndex: ', clickedIndex);
   
    setSelectedQuestionIndex(clickedIndex);
    setSelectedQuestionId(questionId);

    // Fetch question data for the clicked question ID
    getData(apiPaths.questionbyid + `?id=${questionId}`).then((response) => {
      if (response.result) {
        setQuestionData(response.result);
      }
    });
    
  };

  const link = (params) => {
    return (
      // <div className="text-link" onClick={() => handleQuestionClick(testData[params.rowIndex].libraryTestId)}>
      //   {params?.value}
      // </div>
       <div className="text-link" onClick={() => handleQuestionClick(params.data.libraryTestId)}>
        {params?.value}
      </div>
    );
  };

  const qIDlink = (params) => {
    return (
      <div className="text-link" onClick={() => handleQuestionIdClick(params.value)}>
        {params?.value}
      </div>
    );
  };
  const button = (params) => {
    return (
      <div>
        <IconButton className="delete-icon" style={{ padding: "0px", marginLeft: "10px" }} aria-label="delete" onClick={() => { handleClickOpen(params) }}>
          <DeleteIcon />
        </IconButton>
      </div>
    );
  };
  const questionColumnDefs = [
    { headerName: "Index", valueGetter: "node.rowIndex + 1" }, // Adds 1 to the index to make it 1-based
    { headerName: "Question IDs", field: "value", valueGetter: "data", cellRendererFramework: qIDlink, filter:true }, // Display the question IDs
    // {
    //   headerName: "Question",
    //   field: "questionPlainText",
    //   width: 200,
    //   filter: true,
    //   tooltipField: "questionPlainText",
    // },
    { headerName: "Actions", field: "actions", cellRendererFramework: button, },
  ];
  
  const columnDefs = [
    { headerName: "Test Name", 
      field: "testName", 
      cellRendererFramework: link ,
      filter: true,
    },
    { headerName: "Description", 
      field: "description" ,
      filter: true,
    },
    { headerName: "Question Count", 
      field: "questionCount" ,
      filter: true,
    },
    { headerName: "Locked",
      field: "locked" 
    },
    { headerName: "Subject", 
      field: "subject" ,
      filter: true,
    },
    { headerName: "Test Mode", 
      field: "testMode" ,
      filter: true,
    },
    { headerName: "Test Type", 
      field: "testType" ,
      filter: true,
    },
    { headerName: "Test Time (mins)", 
      field: "testTimeInMins" ,
      filter: true,
    },
    { headerName: "Created By", 
      field: "createdBy" ,
      filter: true,
    },
    { headerName: "Created Date", 
      field: "createdDate",
      valueFormatter: (createdDate) => {
            return createdDate ? moment(createdDate.value).format("DD-MM-YYYY hh:mm A") : '';
          },
          filter: true,
     },
    { headerName: "Updated By", 
      field: "updatedBy" ,
      filter: true,
    },
    { headerName: "Updated Date", 
      field: "updatedDate" ,
      valueFormatter: (updatedDate) => {
        return updatedDate ? moment(updatedDate.value).format("DD-MM-YYYY hh:mm A") : '';
      },
      filter: true,
    },
  ];

  const gridOptions = {
    columnDefs,
    rowData: value == "Custom-Tests" ? customTestData : normalTestData,
  };

  const openAddQuestionModal = () => {
    setOpenAddQnModal(true)
  }

  const handleDownload = () => {
    setShowDownloadModal(true);
  }

  const handleDownloadClose = () => {
    setShowDownloadModal(false);
  }

  const handleDownloadTest = () => {
    getInstutueApp(`${apiPaths.downloadTest}?libraryTestId=${libraryTestId}&includeExplanation=${includeExplanation}&includeQuestion=${includeQuestion}&includeAnswer=${includeAnswer}`, null, {
        tenantId: getUserDetails().tenantId,
        userEmail: getUserDetails().email
    }, 'blob')
      .then(async (res) => {
        const blob = new Blob([res.data], { type: res.headers['content-type'] });
        let fileName = "downloaded-file";
        const disposition = res.headers['content-disposition'];
        if (disposition && disposition.includes("filename=")) {
          const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match != null && match[1]) {
            fileName = match[1].replace(/['"]/g, '');
          }
        }

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.log(err));
  }

  const handleCloseAddQuestionModal = () => {
    setOpenAddQnModal(false)
  }
  const handleClickOpen = (data) => {
    setDeletedQnId(data.data)
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
const handleDeleteQuestion = async () => {

    const response = await deleteInstituteAppData(apiPaths.deleteQuestionFromTest, {
      data: [],
      params: { questionId: deletedQnId,
      libraryTestId: libraryTestId   
       },
      headers: {
        tenantId: getUserDetails().tenantId,
        userEmail: getUserDetails().email,
      },

    })
    handleClose()
    if (response.result == true) {
      Toaster(toast.TYPE.SUCCESS, "Question deleted Successfully");
      refreshTopicQuestions();
    } else {
      Toaster(toast.TYPE.ERROR, "Error in deleting question");
    }
  }
  const AddQuestionClick = async () => {
      const response = await postInstituteAppData(apiPaths.addQuestionToTest, {
        data: [],
        params: { questionId: addedQuestionId,
        libraryTestId: libraryTestId   
           },
        headers: {
          tenantId: getUserDetails().tenantId,
          userEmail: getUserDetails().email,
        },
  
      })
      handleCloseAddQuestionModal()
      if (response.result == true) {
        Toaster(toast.TYPE.SUCCESS, "Question Id Added Successfully");
        refreshTopicQuestions();
      } else {
        Toaster(toast.TYPE.SUCCESS, "Error in adding question Id");
      }
    }
    const refreshTopicQuestions = () => {
      handleQuestionClick(libraryTestId);
    }

  return (
    <div>
      <h2>Tests</h2>
      <Box sx={{ width: '100%', typography: 'body1', marginBottom: "20px" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="wrapped label tabs example"
      >
        <Tab value="Normal-Tests" label="Normal Tests"></Tab>
        <Tab value="Custom-Tests" label="Custom Tests"></Tab>
      </Tabs>
      
    </Box>
      {loading && <p>Loading...</p>}
      {!loading && testData && testData.length > 0 && (
        <Grid
          gridOptions={{
            ...gridOptions,
            pagination: true,
            paginationPageSize: 10,
          }}
          parent="qb"
        />
      )}

      {selectedQuestionId && (
        <QuestionViewModal
    open={true}
    handleClose={() => {
      setSelectedQuestionId(null);
      setSelectedQuestionIndex(-1);
      setQuestionData({});
    }}
    selectedQuestionEditable={selectedQuestionEditable}
    isEditEnabled={true}
    prevQuestion={
      selectedQuestionIndex > 0
        ? questionDataList[selectedQuestionIndex - 1]
        : null
    }
    nxtQuestion={
      selectedQuestionIndex < questionDataList.length - 1
        ? questionDataList[selectedQuestionIndex + 1]
        : null
    }
    questionData={questionData}
    QBCount={QBCount}
    selectedQuestion={selectedQuestionId}
    setId={(e) => {
      setSelectedQuestionId(e);
      setSelectedQuestionIndex(questionDataList.indexOf(e));
      // Fetch question data for the clicked question ID
      getData(apiPaths.questionbyid + `?id=${e}`).then((response) => {
        if (response.result) {
          setQuestionData(response.result);
        }
      });
    }}
  />
  )}

  {questionDataList.length > 0 && (
  <>
    <h2>Question Data
      <Button variant="contained" onClick={openAddQuestionModal} style={{ marginLeft: "30px" }}>Add Question Id</Button>
      <Button variant="contained" onClick={handleDownload} style={{ marginLeft: "30px" }}>Download</Button>
    </h2>
    <Grid
      gridOptions={{
        columnDefs: questionColumnDefs,
        rowData: questionDataList,
        pagination: questionDataList.length > 10,
        paginationPageSize: 10,
      }}
      parent="questionData"
    />
  </>
)}

<Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Make sure you remove every link to the question—in both the question bank and any tests—before you delete it. Question Id: <strong>{deletedQnId}</strong> ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>Close</Button>
          <Button variant="contained"
            onClick={handleDeleteQuestion} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAddQnModal}
        onClose={handleCloseAddQuestionModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Add Question Id<CloseIcon className="close-icon" onClick={handleCloseAddQuestionModal}/></DialogTitle>
        <DialogContent style={{paddingTop:"10px"}}>
          <DialogContentText id="alert-dialog-description">
              <div class="">
                      <TextField
                        id="outlined-basic"
                        label="Question Id"
                        placeholder="Question Id"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        size="small"
                        value={addedQuestionId}
                        style={{ width: "100%" }}
                        onChange={(item) => {
                          setAddedQuestionId(item.target.value);
                        }}
                      />
                  </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button variant="contained" color="error" onClick={handleCloseAddQuestionModal}>Close</Button> */}
          <Button variant="contained" onClick={AddQuestionClick} autoFocus>Add</Button>
        </DialogActions>
      </Dialog>
      <Modal open={showDownloadModal} onClose={handleDownloadClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ p: 2, width: 400, backgroundColor: '#fff', borderRadius: '4px', boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.15)' }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Download Tests
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={includeExplanation}
                onChange={(e) => setIncludeExplanation(e.target.checked)}
              />
            }
            label="Include Explanation"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={includeAnswer}
                onChange={(e) => setIncludeAnswer(e.target.checked)}
              />
            }
            label="Include Answer"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={includeQuestion}
                onChange={(e) => setIncludeQuestion(e.target.checked)}
              />
            }
            label="Include Question"
          />
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" onClick={handleDownloadTest}>
              Download
            </Button>
            <Button variant="outlined" sx={{ ml: 2 }} onClick={handleDownloadClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
  
};

export default Qb;
